(function(){
    function Viewer(){
        this.ViewerInObjectsInit = function () {}
    }
    proj.viewer = new Viewer();    
})();